import { DynamicBlock, Image } from '@tribeplatform/gql-client/types'
import { useSlateKitContext } from '@tribeplatform/react-slate-kit/hooks'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { Icon, SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { ColumnBlockIcon } from './ColumnBlockIcon.js'
import { SlateTreeItemInfo } from './types.js'

export const SlateTreeItemIcon = ({
  item,
  dynamicBlock,
  isColumnBlock,
}: {
  item: SlateTreeItemInfo
  dynamicBlock?: DynamicBlock
  isColumnBlock?: boolean
}) => {
  const { kit } = useSlateKitContext()
  const { name: dynamicBlockName } = kit.getDynamicBlock()

  const {
    data: {
      name,
      config: { Icon: CustomIcon },
    },
  } = item
  if (dynamicBlock && dynamicBlockName && dynamicBlockName === name) {
    const iconUrl = ((dynamicBlock.favicon ?? dynamicBlock.image) as Image)?.url
    if (iconUrl) {
      return (
        <Avatar
          size="lg"
          rounded="sm"
          name={dynamicBlock.name}
          src={iconUrl}
          className="flex"
        />
      )
    }
  }

  if (isColumnBlock) {
    return <ColumnBlockIcon item={item} />
  }

  return <Icon size="md">{CustomIcon ?? <SvgIcon name="block" />}</Icon>
}
